<template>
  <div class="availability">
    <ul class="availability__tiers">
      <slot v-if="item && getValidDeliveryTimesQtySmall().length > 0">
        <li
          v-for="(time, index) in getValidDeliveryTimesQtySmall()" :key="index"
          class="availability__tier"
          :class="{'--is-active': boxQty >= time.qty && boxQty <= getTillQtyRaw(time.index)}"
        >
          <div>
            <b class="availability__quantity">{{ time.qty }}-{{ getTillQty(time.index) }}</b> <slot>Stück</slot>
          </div>

          <img src="@/assets/images/icon-arrow-matrix-overview.svg">

          <div>
            <span class="availability__time" :class="{'--is-disabled': time.time === 'nicht verfügbar'}">{{ time.time.replace("in", "mind.").replace("Tagen", "Tage") }}</span>
            <Popper v-if="index == getValidDeliveryTimesQtySmall().length -1" placement="top">
              <span class="u-text-muted"><a class="availability__detail">Details anzeigen</a></span>
              <template v-slot:popover>
                <p>Verfügbarkeiten & Lieferzeiten</p>

                <ul class="availability__tiers">
                  <li
                    v-for="(time, index) in getValidDeliveryTimesQty()" :key="index"
                    class="availability__tier"
                    :class="{'--is-active': boxQty >= time.qty && boxQty <= getTillQtyRaw(index), '--is-hidden': time.time === 'nicht verfügbar'}"
                  >
                    <div>
                      <b class="availability__quantity">{{ time.qty }} - {{ getTillQty(index) }}</b> <slot>Stück</slot>
                    </div>

                    <img src="@/assets/images/icon-arrow-matrix-overview.svg">
                      <span v-if="time.time != 'nicht verfügbar'" class="availability__quantity" :class="{'--is-disabled': time.time === 'nicht verfügbar'}">{{ time.time.replace("versandfertig", "") }} versandfertig</span>
                      <span v-else class="availability__quantity" :class="{'--is-disabled': time.time === 'nicht verfügbar'}">{{ time.time }}</span>
                    <div>
                    </div>
                  </li>
                </ul>
              </template>
            </Popper>
          </div>
        </li>

        <li class="availability__tier">
          <Popper placement="top">
            <span class="u-text-muted"><a>Später gewünscht?</a></span>
              <template v-slot:popover>
                <slot v-if="boxQty === 1">
                  <b>Sie wünschen eine verzögerte Lieferung?</b><br>Gerne können wir den Versand zu einem späteren Zeitpunkt durchführen. Wählen Sie bei den Liefereinstellungen die Option "Lieferung verzögern" und geben Sie Ihren gewünschten Versandtermin an.
                </slot>
                <slot v-else>
                  <b>Sie wünschen eine verzögerte Lieferung?</b><br>Gerne können wir den Versand zu einem späteren Zeitpunkt durchführen. Geben Sie Ihren gewünschten Versandtermin bitte im Feld "Anmerkungen zu Ihrer Bestellung" beim Bezahlvorgang an (unter "Rechnungsdetails").
                </slot>
              </template>
          </Popper>
        </li>
      </slot>

      <slot v-else>
        <li class="availability__tier --is-active">
          <div>Laden…</div>
          <img src="@/assets/images/icon-arrow-matrix-overview.svg">
          <div>…</div>
        </li>

        <li class="availability__tier">
          <div>Laden</div>
          <img src="@/assets/images/icon-arrow-matrix-overview.svg">
          <div>…</div>
        </li>

        <li class="availability__tier">
          <span class="u-text-muted"><i class="icon icon-ellipsis-h"></i> <a>Details anzeigen</a></span>
        </li>
      </slot>
    </ul>
  </div>
</template>

<script>
import Popper from '@/components/Popper';
import { logicMixin } from '@/mixins/LogicMixin';
import { UiMixin } from '@/mixins/UiMixin';

export default {
  name: 'SummaryAvailability',
  props: {
    quantity: {
      type: Number,
      default: 0
    },
    item: {}
  },
  mixins: [UiMixin, logicMixin],
  components: {
    Popper
  },
  data () {
    return {
      filteredTimes: [],
      isDataLoaded: false,
      maxStock: 20
    };
  },
  methods: {
    tiersEqualWidth () {
      const tierQtyElements = this.$el.querySelectorAll('.availability__tiers:first-child > .availability__tier > div:first-child');
      let longestWidth = 0;

      tierQtyElements.forEach((item, key) => {
        if (item.offsetWidth > longestWidth) {
          longestWidth = item.offsetWidth;
        }
      });

      tierQtyElements.forEach((item, key) => {
        item.style.setProperty('width', longestWidth + 8 + 'px');
      });
    },

    getValidDeliveryTimesQty: function() {
      const ret = [];
      if (this.filteredTimes) {
        this.filteredTimes.forEach(element => {
          if (this.clientDeliveryTimesQty[1] === false || element.qty <= this.clientDeliveryTimesQty[1]) {
            ret.push(element);
          }
        });
        this.isDataLoaded = true;
      }
      return ret;
    },

    getValidDeliveryTimesQtySmall: function() {
      const ret = [];
      const vals = this.getValidDeliveryTimesQty();
      if (vals.length > 0) {
        ret.push({ ...vals[0], index: 0 });
        if (vals.length > 1) {
          if (vals.length > 1 && this.boxQty >= vals[1].qty) {
            var wasIn = false;
            vals.forEach((v, idx) => {
              if (v.qty > this.boxQty && wasIn === false) {
                ret.push({
                  ...vals[idx - 1],
                  index: idx - 1
                });
                wasIn = true;
              } else if (v.qty === this.boxQty && wasIn === false) {
                ret.push({
                  ...vals[idx],
                  index: idx
                });
                wasIn = true;
              }
            });

            if (wasIn === false) {
              ret.push({
                ...vals[vals.length - 1],
                index: vals.length - 1
              });
            }
          } else {
            const second = { ...vals[vals.length - 1], index: vals.length - 1 };
            let index = 1;
            vals.forEach((v, i) => {
              if (v.time === 'nicht verfügbar') {
                index = i + 1;
              }
            });
            second.qty = vals[index].qty;
            second.time = vals[index].time;
            ret.push(second);
          }
        }
        this.isDataLoaded = true;
      }
      return ret;
    },

    getTillQty: function(index) {
      if (this.filteredTimes.length >= index + 2) {
        if (this.clientDeliveryTimesQty[1] === false) {
          return (this.filteredTimes[index + 1].qty - 1);
        }
        return Math.min(this.clientDeliveryTimesQty[1], this.filteredTimes[index + 1].qty - 1);
      }
      if (this.clientDeliveryTimesQty[1] === false) {
        return '9000';
      }
      return this.clientDeliveryTimesQty[1];
    },

    getTillQtyRaw: function(index) {
      if (this.filteredTimes.length >= index + 2) {
        if (this.clientDeliveryTimesQty[1] === false) {
          return this.filteredTimes[index + 1].qty - 1;
        }
        return Math.min(this.clientDeliveryTimesQty[1], this.filteredTimes[index + 1].qty - 1);
      }
      if (this.clientDeliveryTimesQty[1] === false) {
        return Number.MAX_SAFE_INTEGER;
      }
      return Math.min(this.clientDeliveryTimesQty[1], Number.MAX_SAFE_INTEGER);
    },

    entryToDeliveryTimesQtyArray(timeQtyArray, qty, product) {
      const time = this.calcDeliveryTimeFast(qty, product);
      if (qty in timeQtyArray) {
        if (timeQtyArray[qty] < time && timeQtyArray[qty] !== 'nicht verfügbar') {
          timeQtyArray[qty] = time;
        }
      } else {
        if (timeQtyArray[qty] !== 'nicht verfügbar') {
          timeQtyArray[qty] = time;
        }
      }
    },

    calcDeliveryTimeFast(qty, product) {
      var minTime = 0;
      var maxTime = 0;

      var addThreshold = 0;
      var minTimeProduct = 0;
      var maxTimeProduct = 0;

      // add single delivery time
      const deliveryTime = product.delivery_time;
      if (
        product.stock_quantity + product.custom_delivery_qty.threshold_1 - 1 <
              qty * product.quantity &&
              product.custom_delivery_qty.threshold_1_time > addThreshold
      ) {
        addThreshold = product.custom_delivery_qty.threshold_1_time;
      } else if (product.stock_quantity < qty * product.quantity) {
        if (deliveryTime !== '') {
          const numbers = deliveryTime.split('-');
          if (
            numbers.length === 1 &&
                      parseInt(numbers[0]) > minTimeProduct &&
                      parseInt(numbers[0]) > maxTimeProduct
          ) {
            minTimeProduct = parseInt(numbers[0]);
            maxTimeProduct = parseInt(numbers[0]);
          } else if (
            numbers.length === 3 &&
                      parseInt(numbers[1]) > minTimeProduct &&
                      parseInt(numbers[1]) > maxTimeProduct
          ) {
            minTimeProduct = parseInt(numbers[1]);
            maxTimeProduct = parseInt(numbers[1]);
          } else if (
            numbers.length === 4 &&
                      parseInt(numbers[1]) > minTimeProduct &&
                      parseInt(numbers[2]) > maxTimeProduct
          ) {
            minTimeProduct = parseInt(numbers[1]);
            maxTimeProduct = parseInt(numbers[2]);
          }
        }
      }

      if (addThreshold > minTimeProduct && addThreshold > maxTimeProduct) {
        minTime += addThreshold;
        maxTime += addThreshold;
      } else {
        minTime += minTimeProduct;
        maxTime += maxTimeProduct;
      }

      if (product.fut_days > minTime || product.fut_days > maxTime) {
        minTime = product.fut_days + addThreshold;
        maxTime = product.fut_days + addThreshold;
      }

      var time = (minTime + maxTime) / 2;
      var wasIn = false;
      if (typeof (this.$store.getters.getDelTimeSettings) !== 'undefined' && Array.isArray(this.$store.getters.getDelTimeSettings)) {
        this.$store.getters.getDelTimeSettings.forEach(s => {
          if (s.min <= qty && wasIn === false) {
            if (typeof (product.prepackaged) !== 'undefined' && qty <= product.prepackaged.qty) {
              time += s.value_lvl1;
            } else {
              time += s.value_lvl3;
            }
            wasIn = true;
          }
        });
      }

      return time;
    }
  },

  mounted () {
    this.doReplace();
    this.$store.getters.getListItemsLevel1Unfiltered.forEach(lvl1 => {
      if (lvl1.id === this.item.id) {
        this.item = lvl1;
      }
    });
    this.filteredTimes = this.clientDeliveryTimesQty[0];
  },

  computed: {
    clientDeliveryTimesQty() {
      const mergedQtyTempAll = {};
      var maxQtyAll = false;
      var allQtys = [1];
      /* if (typeof (this.item.prepackaged) !== 'undefined' && this.item.prepackaged.quantity > 0) {
        allQtys.push(this.item.prepackaged.quantity);
      } */
      this.item.products.forEach(product => {
        if (product.stock_quantity !== 0) {
          allQtys.push(product.stock_quantity);
          allQtys.push(product.stock_quantity + 1);
        }
        allQtys.push(product.stock_quantity + product.custom_delivery_qty.threshold_1 - 1);
        allQtys.push(product.stock_quantity + product.custom_delivery_qty.threshold_1);
        allQtys.push(product.stock_quantity + product.custom_delivery_qty.threshold_1 + 1);

        this.getReplaceProductsFor(product.product).forEach(r => {
          if (r.stock_quantity !== 0) {
            allQtys.push(r.stock_quantity);
            allQtys.push(r.stock_quantity + 1);
          }
          allQtys.push(r.stock_quantity + r.custom_delivery_qty.threshold_1 - 1);
          allQtys.push(r.stock_quantity + r.custom_delivery_qty.threshold_1);
          allQtys.push(r.stock_quantity + r.custom_delivery_qty.threshold_1 + 1);
        });
      });
      if (typeof (this.$store.getters.getDelTimeSettings) !== 'undefined' && Array.isArray(this.$store.getters.getDelTimeSettings)) {
        this.$store.getters.getDelTimeSettings.forEach(s => {
          allQtys.push(s.min);
        });
      }
      allQtys = [...new Set(allQtys)];
      this.item.products.forEach(product => {
        if (product.type === 'box') {
          return;
        }
        const mergedQtyTemp = {};
        var pQtyTemp = {};
        var atLeastOne = false;
        var maxQty = false;
        allQtys.forEach(qty => {
          this.entryToDeliveryTimesQtyArray(pQtyTemp, qty, product);
        });

        for (const [key, value] of Object.entries(pQtyTemp)) {
          mergedQtyTemp[key] = [value];
        }

        if (product.custom_delivery_qty.allow_backorders === 'ja') {
          atLeastOne = true;
        } else if (maxQty === false || maxQty < product.stock_quantity) {
          maxQty = product.stock_quantity;
        }

        this.getReplaceProductsFor(product.product).forEach(r => {
          r.quantity = product.quantity;
          var pQtyTempR = {};
          allQtys.forEach(qty => {
            this.entryToDeliveryTimesQtyArray(pQtyTempR, qty, r);
          });

          for (const [key, value] of Object.entries(pQtyTempR)) {
            if (!(key in mergedQtyTemp)) {
              mergedQtyTemp[key] = [value];
            } else {
              mergedQtyTemp[key].push(value);
            }
          }

          if (r.custom_delivery_qty.allow_backorders === 'ja') {
            atLeastOne = true;
          } else if (maxQty === false || maxQty < r.stock_quantity) {
            maxQty = r.stock_quantity;
          }
        });

        for (const [key, value] of Object.entries(mergedQtyTemp)) {
          mergedQtyTemp[key] = Math.min(...value);
        }

        var lastVal = false;
        const keyIter = Object.keys(mergedQtyTemp).map(i => parseInt(i)).sort((a, b) => b - a);
        keyIter.forEach(k => {
          if (lastVal === false) {
            lastVal = mergedQtyTemp[k];
          } else {
            if (mergedQtyTemp[k] > lastVal) {
              mergedQtyTemp[k] = lastVal;
            } else {
              lastVal = mergedQtyTemp[k];
            }
          }
        });

        for (const [key, value] of Object.entries(mergedQtyTemp)) {
          if (!(key in mergedQtyTempAll)) {
            mergedQtyTempAll[key] = [value];
          } else {
            mergedQtyTempAll[key].push(value);
          }
        }

        if (!atLeastOne && (maxQtyAll === false || maxQtyAll > maxQty)) {
          maxQtyAll = maxQty;
        }
      });

      for (const [key, value] of Object.entries(mergedQtyTempAll)) {
        mergedQtyTempAll[key] = Math.max(...value);
      }

      var lastVal = false;
      const keyIter = Object.keys(mergedQtyTempAll).map(i => parseInt(i)).sort((a, b) => a - b);
      keyIter.forEach(k => {
        if (lastVal === false) {
          lastVal = mergedQtyTempAll[k];
        } else {
          if (mergedQtyTempAll[k] < lastVal) {
            mergedQtyTempAll[k] = lastVal;
          } else {
            lastVal = mergedQtyTempAll[k];
          }
        }
      });

      var deliveryTimesQty = [];
      const deliveryTimesQtyTemp2 = [];
      // Darstellung
      Object.entries(mergedQtyTempAll).forEach(([k, entry]) => {
        k = parseInt(k);
        if (k <= 0) {
          return;
        }
        var time = '';
        if (entry === 'nicht verfügbar') {
          time = 'nicht verfügbar';
        } else if (entry === 0) {
          time = 'sofort versandfertig';
        } else if (entry === 1) {
          time = 'sofort versandfertig';
        } else if (entry > 1 && entry <= 14) {
          time = `in ${entry} Tagen`;
        } else {
          time = `ab ${this.getDeliveryReadyDateString(entry)}`;
        }
        deliveryTimesQtyTemp2.push({
          qty: k,
          time: time
        });
      });

      deliveryTimesQtyTemp2.sort((a, b) => {
        if (a.qty === b.qty) {
          return 0;
        }

        return (a.qty < b.qty) ? -1 : 1;
      });
      const arrLength = deliveryTimesQtyTemp2.length;
      var indexRemove = 0;
      for (var i = arrLength - 1; i >= 0; --i) {
        if (deliveryTimesQtyTemp2[i].time === 'nicht verfügbar') {
          indexRemove = i;
          break;
        }
      }

      while (indexRemove > 0) {
        deliveryTimesQtyTemp2.splice(indexRemove, 1);
        indexRemove--;
      }

      var lastKey = '';
      deliveryTimesQtyTemp2.forEach(entry => {
        if (lastKey !== entry.time) {
          deliveryTimesQty.push(entry);
        }
        lastKey = entry.time;
      });

      var oneNotAvailable = false;
      this.item.products.forEach(product => {
        var prodNotAvailable = false;
        if (product.stock_status !== 'instock') {
          prodNotAvailable = true;
        }

        var allReplacerNotAvailable = this.getReplaceProductsFor(product.product).length;
        this.getReplaceProductsFor(product.product).forEach(r => {
          if (r.stock_status !== 'instock') {
            allReplacerNotAvailable--;
          }
        });

        if (prodNotAvailable && allReplacerNotAvailable === 0) {
          oneNotAvailable = true;
        }
      });

      if (oneNotAvailable) {
        deliveryTimesQty[0].time = 'nicht verfügbar';
        if (deliveryTimesQty[1]) {
          deliveryTimesQty[1].qty = 20;
        }
      }

      if (maxQtyAll === 0) {
        maxQtyAll = 9000;
        deliveryTimesQty = [{
          qty: 1,
          time: 'nicht verfügbar',
        }];
      }
      return [deliveryTimesQty, maxQtyAll];
    }
  },

  watch: {
    isDataLoaded () {
      this.$nextTick(() => {
        this.tiersEqualWidth();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * Summary Availability
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Shipping availablity matrix
 * @since 2021-09-20
**/

$component: 'availability';

.#{$component} {
  @include font-size($font-size-sm);

  &__tiers {
    @include unlist;
  }

  &__tier {
    display: flex;
    @include padding((map-get($spacers, 1) / 2.8) map-get($spacers, 1));

    &.--is-active {
      border-radius: $border-radius-lg;
      background-color: #DBFFE8;
      box-shadow:
        0px 1px 0px rgba(0, 0, 0, 0.08),
        inset 0px 1px 1px rgba(0, 0, 0, 0.18);
    }

    img {
      @include margin(0 map-get($spacers, 1));
      margin-left: -1px;
    }

    a {
      color: $ink-lightest;
      text-decoration: underline;
      cursor: pointer;

      @include hover() {
        color: $ink-lighter;
      }
    }

    .icon {
      @include margin-right(map-get($spacers, 1));
      position: relative;
      top: 3px;
    }
  }

  .popper-wrapper &__tier {
    @include margin-bottom(map-get($spacers, 1));
  }

  &__quantity {
  }

  &__time {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .availability__detail{
    margin-left: 5px;
  }
  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    &__tier {
      img {
        display: none;
      }

      > div:first-child {
        &:after {
          content: ':';
        }
      }
    }
  }
}
</style>
